import { render, staticRenderFns } from "./ListRolePage.vue?vue&type=template&id=c84d4e76"
import script from "./ListRolePage.vue?vue&type=script&lang=js"
export * from "./ListRolePage.vue?vue&type=script&lang=js"
import style0 from "./ListRolePage.vue?vue&type=style&index=0&id=c84d4e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports